module.exports = __webpack_public_path__ + "media/images/dark_checkmark-54eceff0c5ea5c0ac45f40116d27731d.svg";